import React, { useState } from 'react';
import SafeIcon from '../../../common/SafeIcon';
import DealCard from '../../pipeline/DealCard';
import BaseModal from '../../modals/BaseModal';
import DealForm from '../../forms/DealForm';
import { useCRM } from '../../../context/CRMContext'; // Added import

export default function PipelineSection({ project }) {
  // Use real deals from context filtered by project
  const { deals, companies } = useCRM();
  const [isDealModalOpen, setIsDealModalOpen] = useState(false);

  const projectDeals = deals.filter(deal => deal.project_id === project.id || deal.project_id === project.project_id);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-xl font-bold text-slate-900">CRM Pipeline</h2>
          <p className="text-sm text-slate-500">Oversikt over alle salgsmuligheter i {project.name}</p>
        </div>
        <button 
          onClick={() => setIsDealModalOpen(true)}
          className="flex items-center px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors shadow-sm"
        >
          <SafeIcon icon="➕" className="mr-2" /> Ny salgsmulighet
        </button>
      </div>

      {projectDeals.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projectDeals.map(deal => {
            const company = companies.find(c => c.company_id === deal.company_id);
            return (
              <DealCard 
                key={deal.deal_id} 
                deal={deal} 
                company={company}
                onEdit={() => {}} 
              />
            );
          })}
        </div>
      ) : (
        <div className="bg-white rounded-xl border border-slate-200 shadow-sm min-h-[300px] flex flex-col items-center justify-center p-8">
          <div className="w-16 h-16 bg-slate-50 rounded-full flex items-center justify-center mb-4">
            <SafeIcon icon="💰" className="text-3xl text-slate-400" />
          </div>
          <h3 className="text-lg font-medium text-slate-900 mb-2">Ingen salgsmuligheter</h3>
          <p className="text-slate-500 text-center max-w-md mb-6">
            Det er ikke opprettet noen salgsmuligheter for dette prosjektet enda.
          </p>
          <button 
            onClick={() => setIsDealModalOpen(true)}
            className="text-primary-600 font-medium hover:text-primary-700 hover:underline"
          >
            Opprett første salgsmulighet
          </button>
        </div>
      )}

      {/* Deal Modal */}
      <BaseModal isOpen={isDealModalOpen} onClose={() => setIsDealModalOpen(false)} title="Ny salgsmulighet">
        <DealForm 
          onClose={() => setIsDealModalOpen(false)} 
          deal={{ project_id: project.id, title: `Deal: ${project.name}` }} 
        />
      </BaseModal>
    </div>
  );
}